import DialpadIcon from "@mui/icons-material/Dialpad";
import LanguageIcon from "@mui/icons-material/Language";
import LockIcon from "@mui/icons-material/Lock";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokenTemporaryService } from "../../../../services/tokenTemorary.service";

const translationPath = "components.menu.";

interface IMenuUserActions {
  toggleMenu: (open: boolean) => void;
  openModalHandler: () => void;
  openPasswordModalHandler: () => void;
  openPinModalHandler: () => void;
}

const MenuUserActions = ({
  toggleMenu,
  openModalHandler,
  openPasswordModalHandler,
  openPinModalHandler,
}: IMenuUserActions) => {
  const { t } = useTranslation();

  const isTemporaryUser = tokenTemporaryService.hasTemporaryAccessToken();

  const actionButtonSx = (theme: any) => ({
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
    color:
      theme.palette.mode === "light"
        ? theme.palette.grey[800]
        : theme.palette.grey[300],
    height: 50,
    borderRadius: 2,
    width: "100%",
    textTransform: "capitalize",
  });

  const runAction = (action: () => void) => {
    toggleMenu(false);
    action();
  };

  return (
    <Stack direction={"column"} spacing={2} mx={2} mb={4}>
      {!isTemporaryUser && (
        <>
          <Button
            onClick={() => runAction(openPasswordModalHandler)}
            sx={actionButtonSx}
            startIcon={<LockIcon />}
          >
            <Typography>{t(translationPath + "change_password")}</Typography>
          </Button>
          <Button
            onClick={() => runAction(openPinModalHandler)}
            sx={actionButtonSx}
            startIcon={<DialpadIcon />}
          >
            <Typography>{t(translationPath + "change_pin")}</Typography>
          </Button>
        </>
      )}
      <Button
        onClick={() => runAction(openModalHandler)}
        sx={actionButtonSx}
        startIcon={<LanguageIcon />}
      >
        <Typography>{t(translationPath + "change_language")}</Typography>
      </Button>
    </Stack>
  );
};

export default MenuUserActions;
